// extracted by mini-css-extract-plugin
export default {"menu":"UserMenu_menu__VWlHY","menuLink":"UserMenu_menuLink__gTebf"};